import { createFileRoute } from '@tanstack/react-router'
import { EnvVaultList } from '@/features/env-vault/list'

export const Route = createFileRoute('/env-vault/')({
  component: EnvVaultList,
})
